<template>
	<div v-if="!unitData.style || unitData.style == 'channel_product_col5_1'" class="m-channel-product flex-wrap">
		<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style1 col5">
			<c-image class="image" :src="item.product_img_url"></c-image>
			<div class="info">
				<p class="name ellipsis-2">{{item.product_name}}</p>
				<div class="flex-between-center">
					<div class="price">￥{{item.sale_price}}<del>￥{{item.original_sale_price}}</del></div>
					<div class="tag flex">
						<label>新品</label>
					</div>
				</div>
				<div class="button">立即抢购</div>
			</div>
		</a>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col5_2'" class="m-channel-product flex-wrap">
		<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style2 col5">
			<c-image class="image" :src="item.product_img_url"></c-image>
			<div class="info">
				<p class="name ellipsis-2">{{item.product_name}}</p>
				<div class="flex-between-center">
					<div class="price">￥{{item.sale_price}}</div>
					<div class="button">立即抢购</div>
				</div>
			</div>
		</a>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col4_1'" class="m-channel-product flex-wrap">
		<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style3 col4">
			<c-image class="image" :src="item.product_img_url"></c-image>
			<div class="info">
				<p class="name ellipsis-2">{{item.product_name}}</p>
				<div class="banner flex-between-center">
					<div class="price">￥{{item.sale_price}}<del>￥{{item.original_sale_price}}</del></div>
					<div class="count">累计已售<br>{{item.product_count}}件</div>
				</div>
			</div>
		</a>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col2_1'" class="m-channel-product flex-wrap">
		<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style4 col2 flex">
			<c-image class="image" :src="item.product_img_url"></c-image>
			<div class="info flex-grow">
				<p class="name ellipsis-2">{{item.product_name}}</p>
				<div class="price flex-between">
					<p>￥{{parseFloat(item.original_sale_price)}}<br>日常价</p>
					<p>￥{{parseFloat(item.tag_sale_price)}}<br>零售价</p>
					<strong>￥{{parseFloat(item.sale_price)}}</strong>
				</div>
				<div class="button">超值低价，省{{parseFloat((item.original_sale_price - item.sale_price).toFixed(2))}}元</div>
			</div>
		</a>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-product {
		padding: 40px 0;
		
		.item {
			box-sizing: border-box
			background: #fff;
			
			&.col2 {
				width: 690px;
				margin-left: 20px;
				
				&:nth-child(2n+1) {
					margin-left: 0;
				}
				
				&:nth-child(n+3) {
					margin-top: 20px;
				}
			}
			
			&.col4 {
				width: 318px;
				margin-left: 42px;
				
				&:nth-child(4n+1) {
					margin-left: 0;
				}
				
				&:nth-child(n+5) {
					margin-top: 40px;
				}
			}
			
			&.col5 {
				width: 250px;
				margin-left: 37px;
				
				&:nth-child(5n+1) {
					margin-left: 0;
				}
				
				&:nth-child(n+6) {
					margin-top: 36px;
				}
			}
			
			&.style1 {
				border: 1px solid #E5E5E5;
				
				.image {
					height: 248px;
				}
				
				.info {
					padding: 8px 14px 10px;
					
					.name {
						height: 40px;
						margin-bottom: 10px;
						line-height: 20px;
						font-size: 13px;
					}
					
					.price {
						line-height: 18px;
						font-size: 16px;
						
						del {
							margin-left: 5px;
							font-size: 12px;
							color: #999;
						}
					}
					
					.tag {
						label {
							border: 1px solid #AE7800;
							padding: 0 5px;
							margin-left: 5px;
							line-height: 16px;
							font-size: 12px;
							color: #AE7800;
						}
					}
					
					.button {
						border-radius: 2px;
						margin-top: 22px;
						line-height: 32px;
						font-size: 14px;
						text-align: center;
						color: #fff;
						background: #000;
					}
				}
			}
			
			&.style2 {
				border: 1px solid #E5E5E5;
				
				.image {
					height: 248px;
				}
				
				.info {
					padding: 8px 14px 14px;
					
					.name {
						height: 40px;
						margin-bottom: 12px;
						line-height: 20px;
						font-size: 13px;
						color: #444;
					}
					
					.price {
						line-height: 18px;
						font-size: 16px;
						font-weight: bold;
					}
					
					.button {
						width: 90px;
						border-radius: 45px;
						line-height: 32px;
						font-size: 14px;
						text-align: center;
						color: #fff;
						background: #DE0000;
					}
				}
			}
			
			&.style3 {
				border: 1px solid #eee;
				
				.image {
					height: 316px;
				}
				
				.info {
					padding: 8px 14px 14px;
					
					.name {
						height: 40px;
						margin-bottom: 14px;
						line-height: 20px;
						font-size: 13px;
					}
					
					.banner {
						height: 48px;
						background-image: url('~@/assets/image/decorate/pc_channel_product_col4_1_bg.png');
						background-size: 100% 100%;
					}
					
					.price {
						margin-left: 12px;
						font-size: 20px;
						font-weight: bold;
						color: #fff;
						
						del {
							margin-left: 5px;
							font-weight: normal;
							font-size: 12px;
							opacity: .7;
						}
					}
					
					.count {
						width: 82px;
						line-height: 16px;
						font-size: 12px;
						text-align: center;
						color: #AF7320;
					}
				}
			}
			
			&.style4 {
				height: 250px;
				padding: 15px;
				
				.image {
					width: 220px;
					height: 220px;
					margin-right: 40px;
				}
				
				.info {
					.name {
						height: 56px;
						line-height: 28px;
						font-size: 18px;
					}
					
					.banner {
						height: 48px;
						background-image: url('~@/assets/image/decorate/pc_channel_product_col4_1_bg.png');
						background-size: 100% 100%;
					}
					
					.price {
						position: relative;
						width: 310px;
						height: 59px;
						margin: 32px 0 24px 34px;
						background-image: url('~@/assets/image/decorate/pc_channel_product_col2_1_bg.png');
						background-size: 100% 100%;
						
						p {
							position: absolute;
							top: -20px;
							line-height: 28px;
							font-size: 12px;
							color: #999;
							
							&:nth-child(1) {
								left: -20px;
							}
							
							&:nth-child(2) {
								right: -20px;
							}
						}
						
						strong {
							position: absolute;
							left: 50%;
							top: 12px;
							font-size: 18px;
							color: #fff;
							transform: translate(-50%,0);
						}
					}
					
					.button {
						box-sizing: border-box
						width: 252px;
						border-radius: 20px;
						padding-left: 112px;
						line-height: 40px;
						font-size: 13px;
						color: #AF7320;
						background-color: #FEF3EF;
						background-image: url('~@/assets/image/decorate/pc_channel_product_col2_1_btn.png');
						background-repeat: no-repeat;
						background-size: auto 100%;
					}
				}
			}
		}
	}
</style>
